import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { ILogin, ILoginResponse } from '@common/interfaces';
import { base_url } from '../../../../common/src/lib/urls/shared.urls';
@Injectable({
  providedIn: 'root',
})
export class SignInService {
  private readonly http = inject(HttpClient);
  getToken() {
    return localStorage.getItem('token');
  }

  getUserId() {
    return localStorage.getItem('userId');
  }

  apiSignIn(data: any) {
    return this.http.post<ILoginResponse>(`${base_url}/auth/login`, data);
  }

  handleAzureAndGoogleAuthToken(token: string, authType: string) {
    return this.http.get(`${base_url}/auth/validate-token?authToken=${token}&authType=${authType}`);
  }

  signInWithAzure() {
    return this.http.get(`${base_url}/auth/azure`);
  }

  verifyEmail(email: string) {
    return this.http.post(`${base_url}/auth/verify-email`, { email });
  }

  verifyToken() {
    return this.getToken() === '' ? true : false;
  }

  logOutApi() {
    return this.http.post(`${base_url}/auth/logout?client=WEB`, {});
  }
}
